import { useTheme } from '../../../context/ThemeContext';

export default function Footer() {
  const { isDark } = useTheme();

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className={`relative border-t ${isDark ? 'bg-[#050505] border-[#1A1A1A]' : 'bg-[#F5F5F7] border-[#E8E8ED]'}`}>
      <div className="max-w-6xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <img
              src="https://public.readdy.ai/ai/img_res/8fc1f046-37f3-4160-b853-113098a5d1e3.png"
              alt="A Bot Smarter"
              className="object-contain mb-3"
              style={{ width: 90, height: 90 }}
            />
            <p className={`text-sm leading-relaxed max-w-xs ${isDark ? 'text-[#C9CED6]/50' : 'text-[#6E6E73]'}`}>
              Smarter systems. Better outcomes.<br />
              Building intelligent AI lead systems for service-based businesses.
            </p>
            <p className={`mt-4 text-xs italic ${isDark ? 'text-[#C9CED6]/25' : 'text-[#6E6E73]/50'}`}>A bot smarter.</p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className={`font-semibold text-xs tracking-widest uppercase mb-5 ${isDark ? 'text-[#C9CED6]' : 'text-[#1D1D1F]'}`}>
              <a href="#top">Navigation</a>
            </h4>
            <nav className="flex flex-col gap-3">
              {[
                { label: 'The Problem', id: 'problem' },
                { label: 'The Solution', id: 'solution' },
                { label: 'How It Works', id: 'how-it-works' },
                { label: 'Industries', id: 'industries' },
                { label: 'Results', id: 'results' },
              ].map((link) => (
                <button
                  key={link.id}
                  onClick={() => scrollTo(link.id)}
                  className={`text-sm transition-colors text-left cursor-pointer whitespace-nowrap ${isDark ? 'text-[#C9CED6]/45 hover:text-[#C9CED6]' : 'text-[#6E6E73] hover:text-[#1D1D1F]'}`}
                  rel="nofollow"
                >
                  {link.label}
                </button>
              ))}
            </nav>
          </div>

          {/* Industries */}
          <div>
            <h4 className={`font-semibold text-xs tracking-widest uppercase mb-5 ${isDark ? 'text-[#C9CED6]' : 'text-[#1D1D1F]'}`}>
              <a href="#industries">Industries</a>
            </h4>
            <nav className="flex flex-col gap-3">
              {['Home Services & Trades', 'Law Firms', 'Wellness & Lifestyle Care', 'Insurance Advisory', 'Residential Real Estate'].map((item) => (
                <span key={item} className={`text-sm ${isDark ? 'text-[#C9CED6]/45' : 'text-[#6E6E73]'}`}>{item}</span>
              ))}
            </nav>
          </div>
        </div>

        {/* Bottom */}
        <div className={`mt-16 pt-8 border-t flex flex-col sm:flex-row items-center justify-between gap-4 ${isDark ? 'border-[#1A1A1A]' : 'border-[#E8E8ED]'}`}>
          <p className={`text-xs ${isDark ? 'text-[#C9CED6]/25' : 'text-[#6E6E73]/50'}`}>
            &copy; {new Date().getFullYear()} A Bot Smarter. All rights reserved.
          </p>
          <p className={`text-xs ${isDark ? 'text-[#C9CED6]/20' : 'text-[#6E6E73]/40'}`}>
            Intelligent lead capture &amp; automation systems
          </p>
        </div>
      </div>
    </footer>
  );
}
